import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  getUserInfo(language?: string): Observable<any> {
    let url = this.apiData.apiURL + `api/${this.client}/user/de`;
    if (language) {
      url = this.apiData.apiURL + `api/${this.client}/user/` + language;
    }
    return this.http.get<any>(url);
  }

  deleteLastViewedDocument(documentId: number): Observable<any> {
    const url = this.apiData.apiURL + `api/${this.client}/user/last-viewed-document/${documentId}`;
    return this.http.delete<any>(url);
  }
}
